import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .buttons {
    margin-top: 20px;
  }

  .field-item {
    padding: 5px;
    background-color: #fdfdfd;
    margin-bottom: 10px;
    border: 1px solid #efefef;
    border-radius: 3px;
  }

  .items {
    padding: 32px 0px 0px;
  }

  .delete {
    padding: 34px 0px 0px 15px;
  }

  .tooltip {
    position: absolute;
    padding: 10px 0px 0px 60px;
    width: 100%;
  }

  .icon {
    color: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/styles.js